// src/components/MailServerWarning.jsx
// Warning banner displayed when mail server is down
import React, { useEffect, useState } from 'react';
import { TIMEOUTS } from '../config/timeouts';
import { buildApiUrl } from '../utils/apiUrl';
import '../assets/scss/MailServerWarning.scss';

const MailServerWarning = () => {
    const [isMailServerDown, setIsMailServerDown] = useState(false);

    useEffect(() => {
        // Check mail server health on mount
        checkHealth();

        // Check every 2 minutes
        const interval = setInterval(() => {
            checkHealth();
        }, TIMEOUTS.mailHealthCheckIntervalMs);

        return () => clearInterval(interval);
    }, []);

    const checkHealth = async () => {
        try {
            const response = await fetch(buildApiUrl('health'), {
                credentials: 'include',
            });

            if (!response.ok) {
                // Backend error - assume mail server is down
                setIsMailServerDown(true);
                return;
            }

            const data = await response.json();

            // Only hide warning if mail server is explicitly healthy
            if (data.mailServer === true) {
                setIsMailServerDown(false);
            } else {
                // Mail server is down or status unknown
                setIsMailServerDown(true);
            }
        } catch (error) {
            // Network error or backend unreachable - show warning
            console.error('Health check failed:', error);
            setIsMailServerDown(true);
        }
    };

    if (!isMailServerDown) {
        return null; // Don't render anything if mail server is healthy
    }

    return (
        <div className='mail-server-warning'>
            <div className='warning-content'>
                <span className='warning-icon'>⚠️</span>
                <p>
                    <strong>Vi har for øyeblikket problemer med server.</strong>
                    <br />
                    Skjema vil ikke kunne sendes. Vi prøver å løse problemet så fort vi kan.
                </p>
            </div>
        </div>
    );
};

export default MailServerWarning;
